<div class="change-plan-summary" *ngIf="!!selectedMobilePlan">
  <div class="page-section back-section">
    <button class="button tertiary" (click)="back()"><span class="back-arrow"><</span> Back</button>
  </div>
  <div class="header-section page-section">
    <h1 class="header">Replacing Your Plan</h1>
    <h4 class="sub-header">Please go through the changes made to your current plan, when ready, you can proceed.</h4>
    <p class="promo-note" *ngIf="!isPromoApplicable">The one time 3 Month Plan Introductory Offer has already been used
      on this line. The standard plan cost is reflected below.</p>
  </div>
  <div class="details-part page-section">
    <h2 class="title">Confirm Plan changes:</h2>
    <h5 class="effective-note" *ngIf="!!nextCycle && !!selectedUserPlan?.basePlan?.renewDate">
      Effective on: {{selectedUserPlan.basePlan?.renewDate | date}} 
    </h5>

      <div class="selected-plan-details" *ngIf="!!selectedMobilePlan">
        <p class="title smaller">Your replacement plan details:</p>
        <div class="plan-details">
          <div class="left-details">
            <div class="plan-img" *ngIf="selectedMobilePlan?.details?.data > 0">
              <p class="data-size">{{selectedMobilePlan?.details?.data / 1024}}</p>
              <p class="caption">GB</p>
            </div>
            <div class="plan-img tt" *ngIf="selectedMobilePlan?.details?.data <= 0">
              <p class="footer"><b>Talk & Text</b></p>
            </div>
            <div>
              <p class="plan-title"><b>{{selectedMobilePlan?.title}}</b></p>
            </div>
          </div>
          <div class="right-details">
            <p class="smallest">Total Amount</p>
            <div class="amount" *ngIf="!loadingPrice">
              <sup class="dollar">$</sup>
              <h2 >{{(
                !!isPromoApplicable ? 
                selectedMobilePlan?.promoMoPrice * (selectedMobilePlan?.subscriptionCycles || 1):
                selectedMobilePlan?.price * (selectedMobilePlan?.subscriptionCycles || 1)
              )}}</h2>
              <p class="smaller mo" *ngIf="selectedMobilePlan?.subscriptionCycles && selectedMobilePlan?.subscriptionCycles  <= 1">/mo</p>
            </div>
            <div class="loading" *ngIf="!!loadingPrice">
              <p><span class="dot"></span><span class="dot"></span><span class="dot"></span></p>
            </div>
          </div>
        </div>
      </div>
    <div class="actions" [class.button-width]="!!isCheckoutFlow">
      <button class="button primary" (click)="userConfirmed()">{{!!isCheckoutFlow ? 'Proceed to checkout' : 'Change plan'}}</button>
      <button class="button secondary" (click)="goToAccountSummary()">Cancel</button>
      <button class="button tertiary back" (click)="back()"><span class="back-arrow"><</span> Back</button>
    </div>
  </div>
</div>